import { createStore } from 'satcheljs';
import { IPropertyViewState } from './schema/IPropertyViewState';

export const getCreatePropertyStore = createStore<IPropertyViewState>('CreatePropertyState', {
  active: {},
  errors: {},
  isSubmittable: false,
});
